<template>
  <div class="room-invite-component" @keyup="keymap">
    <div class="room-invite">
      <div class="room-invite-header">
        <p class="room-invite-title">{{ $t("invite.title") }}</p>
        <GrmCloseBtn class="room-invite-close-button" @click="onClose" />
      </div>
      <div class="room-invite-body">
        <p class="room-invite-description">{{ $t("invite.description") }}</p>
        <ul class="room-invite-list">
          <li class="room-invite-item"><button class="room-invite-button mail" @click="onToggleUsingEmail"/></li>
<!--          <li class="room-invite-item"><button class="room-invite-button facebook" @click="inviteFacebook"/></li>-->
<!--          <li class="room-invite-item"><button class="room-invite-button kakao" @click="onToggleUsingKakao"/></li>-->
          <li class="room-invite-item"><button class="room-invite-button band" @click="inviteBand"/></li>
        </ul>
      </div>
      <div class="room-invite-footer">
        <p class="room-invite-copy-url-description">{{ $t("invite.url.description") }}</p>
        <VButton focus class="room-invite-copy-url-button" @click="copyRoomUrlId">{{ $t("invite.url.copy") }}</VButton>
      </div>
    </div>
  </div>
</template>

<script>
import {mapGetters} from "vuex";
import VButton from "@/components/Common/VButton";
import GrmCloseBtn from "@/components/Common/button/GrmCloseBtn";
import RoomInviteEmail from "@/components/Room/Invite/Email";
import RoomInviteKakao from "@/components/Room/Invite/Kakao";
import * as Bowser from "bowser";
import moment from "moment";

export default {
  name: 'RoomInvite',
  components: {
    VButton,
    GrmCloseBtn,
  },
  data() {
    return {
      facebookAppId: '988289321262078', // TODO Backend App에서 가지고와야하는 값이다.
    }
  },
  created() {
    const appId = this.facebookAppId;
    window.fbAsyncInit = function () {
      window.FB.init({
        appId,
        xfbml: true,
        version: 'v2.7'
      });
    };
    (function (d, s, id) {
      let js, fjs = d.getElementsByTagName(s)[0];
      if (d.getElementById(id)) {
        return;
      }
      js = d.createElement(s);
      js.id = id;
      js.src = "//connect.facebook.net/en_US/sdk.js";
      fjs.parentNode.insertBefore(js, fjs);
    }(document, 'script', 'facebook-jssdk'));
  },
  computed: {
    ...mapGetters('room', ['room'])
  },
  methods: {
    keymap(e) {
      switch (e.keyCode) {
        case 27: // esc
          this.onClose();
          break;
      }
    },

    onToggleUsingEmail() {
      this.$modal(RoomInviteEmail)
    },

    inviteFacebook() {
      if (window.FB) {
        window.FB.ui({
          method: 'share',
          href: 'https://gooroomee.com',
          hashtag: '#gooroomee',// + ',구루미,화상,미팅',
          mobile_iframe: true,
        }, (res) => {
          console.log(res);
        });
        this.onClose();
      } else {
        alert(this.$t('common.errorAlert'))
      }
      this.onClose();
    },

    onToggleUsingKakao() {
      this.$modal(RoomInviteKakao)
    },

    inviteBand() {
      const msg = [
        this.$t('invite.band.msg.title'),
        this.$t('invite.band.msg.roomTitle', { '0' : (this.room.roomTitle || this.room.roomUrlId || '') }),
        this.$t('invite.band.msg.date', { '0' : moment(this.room.beginDate).format('YYYY-MM-DD HH:mm:ss'), '1': (!this.room.endResvDate ? '' : moment(this.room.endResvDate).format('YYYY-MM-DD HH:mm:ss')) }),
        this.$t('invite.band.msg.link', { '0' : location.protocol, '1': location.host, '2': this.room.roomUrlId }),
      ];
      let bandUrl = 'http://band.us/plugin/share?body=' + msg.join( encodeURIComponent('\r\n') );

      if (this.isMobile() || this.isTablet()) {
        bandUrl = 'bandapp://create/post?text=' + msg;
      }

      window.open(
          `${bandUrl}&route=${location.hostname}`,
          'grm_share_band',
          'width=410, height=540, resizable=no'
      );
      this.onClose();
    },

    isMobile() {
      return Bowser.getParser(window.navigator.userAgent).getPlatformType() === 'mobile'
    },

    isTablet() {
      return Bowser.getParser(window.navigator.userAgent).getPlatformType() === 'tablet'
    },

    // TODO 공통으로 뺄 필요가 있는가? (copyToClipboard)
    copyRoomUrlId() {
      const url = location.protocol + '//' + location.host + '/' + this.room.roomUrlId ;

      if(window.clipboardData){
        window.clipboardData.setData('Text', url);
        return true;
      }

      let textarea = document.createElement('textarea');
      try{
        textarea.style.opacity = '0';
        textarea.value = url;
        document.body.appendChild(textarea);

        let rangeToSelect = document.createRange();
        rangeToSelect.selectNodeContents( textarea );

        let selection = window.getSelection();
        selection.removeAllRanges();
        selection.addRange( rangeToSelect );

        try {
          const netscape = window.netscape;
          if(netscape && netscape.security && netscape.security.PrivilegeManager) {
            netscape.security.PrivilegeManager.enablePrivilege('UniversalXPConnect');
          }

          textarea.select();
          document.execCommand('copy', false, null);

          this.$alert(this.$t("invite.url.copied"))
        }catch(e){
          console.error(e);
        }
      }finally{
        textarea.remove();
      }
    },
    onClose() {
      this.$modal('RoomInvite')
    }
  },
}
</script>

<style lang="scss" scoped>
.room-invite-component {
  background-color: rgba(0, 0, 0, 0.4);
  display: flex;
  justify-content: center;
  align-items: center;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  z-index: 9999;
}
.room-invite {
  min-width: 360px;
  border-radius: 10px;
  background-color: #fff;
  box-sizing: border-box;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.4);
  text-align: center;
  overflow: hidden;
}
.room-invite-header {
  height: 40px;
  border-bottom: 1px solid #999;
  padding: 0 10px 0 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.room-invite-title {
  padding-left: 26px;
  background: url('~@/assets/images/group.svg') no-repeat center left / 20px auto;
  font-size: 15px;
  font-weight: 700;
}
.room-invite-close-button {}
.room-invite-body {
  padding: 20px;
}
.room-invite-description {
  font-size: 13px;
  color: #666;
  text-align: left;
}
.room-invite-list {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0 16px;
}
.room-invite-item {}
.room-invite-button {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  opacity: 0.8;
  transition: 0.2s ease-out;
  &.mail {
    background: #21AFFF url('~@/assets/images/social/mail.svg') no-repeat center / 22px auto;
  }
  &.facebook {
    background: url('~@/assets/images/social/facebook.png') no-repeat center / 100% auto;
  }
  &.kakao {
    background: url('~@/assets/images/social/kakao.png') no-repeat center / 100% auto;
  }
  &.band {
    background: url('~@/assets/images/social/band.png') no-repeat center / 100% auto;
  }
  &:hover {
    opacity: 1;
  }
}
.room-invite-footer {
  border-top: 1px solid #ddd;
  padding: 20px;
  background-color: #f1f1f1;
}
.room-invite-copy-url-description {
  font-size: 12px;
  color: #666;
  text-align: left;
}
.room-invite-copy-url-button {
  margin-top: 10px;
}

[grm-device-mobile] {
  .room-invite {
    border-radius: 0;
    display: flex;
    flex-direction: column;
    position: absolute;
    inset: 0;
  }
  .room-invite-body {
    min-height: 0;
    flex: 1;
    padding: 8px;
  }
  .room-invite-list {
    margin-top: 8px;
  }
  .room-invite-footer {
    padding: 8px;
  }
}
</style>